import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { UserForm } from '@/components/pages/Admin/UserManagement/Form/UserForm'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/user/create')({
  component: UserCreatePage,
})

function UserCreatePage() {
  const t = useTranslations('admin.user_management.create')

  return (
    <HomeContentContainer title={t('title')}>
      <UserForm action="create" />
    </HomeContentContainer>
  )
}

